import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-asignar-tecnico',
  templateUrl: './asignar-tecnico.component.html',
  styleUrls: ['./asignar-tecnico.component.css']
})
export class AsignarTecnicoComponent implements OnInit {

  @Input() title: string;
  @Input() ticket;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;


  constructor(private activeModal: NgbActiveModal, private service: UserService) { }

  ngOnInit() {
    this.service.getTecnicos().subscribe(d=>{
      this.tecnicos = d.filter(x=> x.isAvailable==true);
      this.tecnicos.forEach( t =>{
        t.zonas.forEach( z=>{
          this.zonas.push(z);
        });
        this.getProvincias();
      });
    })
  }

  tecnicos = [];
  zonas = [];

  tecnico;
  selectedProvincia;
  selectedLocalidad;

  public decline() {
    this.activeModal.dismiss();
  }

  public accept() {
    this.activeModal.close(this.tecnico);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  provincias = [];
  getProvincias(){
    for(let z of this.zonas){
      if(this.provincias.indexOf(z.provincia)<0) this.provincias.push(z.provincia);
    }
    if(this.provincias.indexOf(this.ticket.zona.provincia)>=0) this.selectedProvincia = this.provincias[this.provincias.indexOf(this.ticket.zona.provincia)];
    else this.selectedProvincia = this.provincias[0];
    
    
    this.getLocalidades();
  }

  localidades = [];
  getLocalidades(){
    this.localidades = [];
    for(let z of this.zonas){
      if(this.selectedProvincia==z.provincia && this.localidades.indexOf(z.localidad)<0) this.localidades.push(z.localidad);
    }
    this.localidades.sort( (a,b) => { return a > b ? 1: -1 });
    if(this.localidades.indexOf(this.ticket.zona.localidad)>=0) this.selectedLocalidad = this.localidades[this.localidades.indexOf(this.ticket.zona.localidad)];
    else this.selectedLocalidad = this.localidades[0];
    this.getTecnicosZona()
  }

  tecnicosZona = [];
  getTecnicosZona(){
    let ret = [];
    for(let t of this.tecnicos){
      for(let z of t.zonas){
        if(z.provincia == this.selectedProvincia && z.localidad == this.selectedLocalidad){
          ret.push(t);
          break;
        }
      }
    }
    
    this.tecnicosZona = ret;
    this.tecnicosZona.sort( (a,b)=> { return a.puntos_mes > b.puntos_mes ? -1 : 1 });
  }

}
